import styled from "@emotion/styled"

export const TextAreaWrapper = styled.div(({theme}) => ({
    width: "100%",
    display: "flex",
    flexDirection: "column",
    flexWrap: "wrap",
    justifyContent: "space-between",
    [theme.breakpoint.down("md")]: {
        flexDirection: "column",
        alignItems: "flex-start"
    }
}))


export const OuterWrapper = styled.div(({theme}) => ({
    width: "100%"
}))


export const TextAreaField = styled("textarea", {
    shouldForwardProp: prop => !["isDisabled", "hasError"].includes(String(prop)),
})<{ isDisabled: boolean, hasError: boolean }>(({
                                                                      theme,
                                                                      isDisabled,
                                                                      hasError
                                                                  }) => ({
    minHeight: 100,
    maxHeight: 300,
    resize: "vertical",
    border: "2px solid",
    width: "100%",
    borderRadius: 6,
    marginTop: 0,
    marginBottom: 0,
    lineHeight: 1.25,
    padding: 10,
    boxSizing: "border-box",
    [theme.breakpoint.down("md")]: {
        maxWidth: "100%",
        flex: "0 0 100%",
        width: "100%"
    },
    borderColor: hasError ? theme.colors.Y300 : theme.colors.N50,
    "&:focus": {
        outline: "none",
        boxShadow: "none",
        borderColor: isDisabled ? theme.colors.N50 : theme.colors.B300,
    },
    "&:not([disabled]):hover": {
        borderColor: isDisabled ? theme.colors.N50 : theme.colors.N80,
    }
}))